module.exports = __webpack_public_path__ + "static/media/letter1.0e4bd7aa.jpg";